import type { TourStep } from "./GuidedTour";

/**
 * Defines all steps for the application's guided tour
 */
export const mainTourSteps: TourStep[] = [
    {
        target: 'button[data-tour="new-chat"]',
        title: "Start a New Chat",
        description: "Click here to start a new conversation with the AI assistant.",
        position: "bottom",
    },
    {
        target: 'input[data-tour="search"]',
        title: "Search Your Chats",
        description: "Quickly find your previous chats by typing here.",
        position: "bottom",
    },
    {
        target: 'div[data-tour="chat-history"]',
        title: "Chat History",
        description: "View and manage all your previous conversations here.",
        position: "right",
    },
    {
        target: 'a[data-tour="documents-viewer"]',
        title: "Documents Viewer",
        description: "Explore all documents for reference & also chat with them.",
        position: "bottom",
    },
    {
        target: "#data-source-details",
        title: "Data Source Details",
        description: "Request access to different data sources here.",
        position: "bottom",
    },
    {
        target: "#chat-input",
        title: "Send a Message",
        description:
            "Type your question here (or choose from the suggestions) and press Enter to send it.",
        position: "top",
    },
    {
        target: 'button[data-testid="send-button"]',
        title: "Send Button",
        description: "Click this button to send your message to the AI assistant.",
        position: "left",
    },
    {
        target: 'div[data-tour="settings-action"]',
        title: "Settings",
        description: "Access functions related to Database and Memory",
        position: "top",
    },
];
